// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetLectureLessonHistoryPagedListRequestModel from '../../model/get-lecture-lesson-history-paged-list-request-model';
import LectureLessonHistoryListPagingResultModel from '../../model/lecture-lesson-history-list-paging-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getLectureLessonHistoryPagedList(request: GetLectureLessonHistoryPagedListRequestModel, config?: RequestConfig) {
    const requestDTO = GetLectureLessonHistoryPagedListRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-lecture-lesson-history-paged-list'] ?? 'agogisCockpit/LectureLessonHistories';
    const response = await service.get<any>(endpointPath, {
      query: {
        lectureLessonId: requestDTO.lectureLessonId,
        lecturerId: requestDTO.lecturerId,
        from: requestDTO.from,
        to: requestDTO.to,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(LectureLessonHistoryListPagingResultModel.toModel(dto));
  },
});
